import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mb-horizontal-menu',
  imports: [NzMenuModule, RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './mb-horizontal-menu.component.html',
  styles: [`
    ul>li:first-child{
      margin-left: 20px;
    }
    li[nz-menu-item] {
      filter: grayscale(100%);
      position: relative;
      border-bottom: none !important; /* Remove any default border/line */
    }
    li[nz-menu-item]::after {
      display: none !important;
    }

    .active-indicator {
      height: 0.25rem; /* h-1 */
      position: absolute;
      bottom: 0;
      left: 0;
      background-color:  #3b82f6; /* fallback color */
      border-radius: 0.125rem;
      width: 100%;
      display: block;
    }
    li[nz-menu-item].ant-menu-item-selected,
    li[nz-menu-item].active,
    li[nz-menu-item].menu-item-active {
      font-weight: 600 !important;
      color: #000 !important;
      filter: grayscale(0%) !important;
      border-bottom: none !important;
    }

    li[nz-menu-item]:hover {
      font-weight: 500;
      color: #000 !important;
      filter: grayscale(0%);
      border-bottom: none !important;
    }

    /* Override any Ant Design menu item bottom border */
    .ant-menu-horizontal > .ant-menu-item::after,
    .ant-menu-horizontal > .ant-menu-submenu::after {
      display: none !important;
    }
  `]
})

export class MbHorizontalMenuComponent {
  constructor(private router: Router) {}
  userType = localStorage.getItem('userType');
}
